const { list } = require("postcss");

$(document).ready(function () {
	// focus into svg path/use is a thing for some reason
	$("svg *").attr("tabindex", -1);

	// Apply a specific class to the html element for browser support of cookies.
	if (LS.cart.cookiesEnabled()) {
		document.documentElement.className =
			document.documentElement.className.replace(
				"supports-no-cookies",
				"supports-cookies"
			);
	}

	// give GA something to hook onto
	$(".pagination .page a").addClass("pagination-link");

	// mobile collapsed panels
	$("[data-collapse-toggle]").on("click", function (e) {
		$(this).toggleClass("collapsed");
		if (!$(this).hasClass("collapsed")) {
			$(this).next("[data-collapse-panel]").fadeIn().addClass("is-shown");
		} else {
			$(this)
				.next("[data-collapse-panel]")
				.fadeOut()
				.removeClass("is-shown");
		}
	});

	if ($(window).width() >= LS.desktopBreakpoint) {
		$("[data-collapse-toggle]").removeClass("collapsed");
		$("[data-collapse-panel]").addClass("is-shown");
	}

	// Smooth scrolling
	$("body").on(
		"click",
		".smoothscroll, .nav-local a, .page-nav-item, .scroll-down-indicator",
		function (e) {
			e.preventDefault();

			var $btn = $(this);
			var trigger = $("#site-header").outerHeight();
			var selector = $btn.attr("href");
			var pos = 0;

			// If the target isn't an on-page anchor, treat it like a normal link
			if (!selector.match(/^#/)) {
				window.location = selector;
				return;
			}

			let $target = $(selector);
			if ($target.length === 0) {
				$target = $("body");
			}

			$("html,body").animate({
				scrollTop: LS.getScrollTo($target, trigger),
			});
		}
	);

	/*
		Floating form labels
	 */
	$(".form-control").on("keyup", function () {
		if ($(this).val() != "") {
			$(this).closest(".form-group").addClass("has-value");
		} else {
			$(this).closest(".form-group").removeClass("has-value");
		}
	});

	if ($(".discover .hero").length) {
		$(".discover .hero").addClass("in");
	}

	/*
	 Home page reviews
	*/
	$(".press-slider .row").slick({
		arrows: false,
		dots: true,
		slidesToShow: 2,
		slidesToScroll: 2,
		responsive: [
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});

	/*
	Discover pages: match heights for Press elements
	 */
	var getEqualizedHeight = function ($elements) {
		var height = 0;
		$elements.each(function () {
			if ($(this).outerHeight() > height) {
				height = $(this).outerHeight();
			}
		});
		return height;
	};
	var equalizePr = function () {
		if ($(window).width() >= 769) {
			$(".pr-logo").height(getEqualizedHeight($(".pr-logo")));
			$(".pr").height("");
		} else if ($(window).width() <= 768) {
			$(".pr").height("");
			$(".pr").height(getEqualizedHeight($(".pr")));
		} else {
			$(".pr-logo").removeAttr("style");
			$(".pr").removeAttr("style");
		}
	};
	if ($(".pr-items").length) {
		$(window).load(function () {
			equalizePr();
		});
		$(window).resize(function () {
			equalizePr();
		});
	}

	/*
	Tables
	 */
	var addTableLabels = function () {
		if ($(window).width() < 768) {
			$("td.has-label").each(function () {
				if ($(this).find(".key").length < 1) {
					$(this).wrapInner('<span class="value" />');
					$(this).prepend(
						'<span class="key">' + $(this).data("label") + "</span>"
					);
				}
			});
		} else {
			$("td.has-label .key").remove();
		}
	};
	if ($("td.has-label").length) {
		addTableLabels();
		$(window).resize(function () {
			addTableLabels();
		});
	}

	/*
	Fit / Model Toggles
	*/
	$(".toggle .controls button").on("click", function (e) {
		e.preventDefault();
		var $parent = $(this).closest(".toggle");
		var $alternate = $parent.find(".alternate");
		$parent.find("button").removeClass("active");
		$(this).addClass("active");
		if ($parent.find(".active").hasClass("show-alternate")) {
			$alternate.addClass("shown");
		} else {
			$alternate.removeClass("shown");
		}
	});

	$(".col-slider").slick({
		centerMode: true,
		centerPadding: "15px",
		dots: true,
		arrows: false,
		variableWidth: true,
		mobileFirst: true,
		infinite: false,
		responsive: [
			{
				breakpoint: LS.tabletBreakpoint - 1,
				settings: "unslick",
			},
		],
	});

	$(".row-slider").slick({
		dots: true,
		arrows: false,
		fade: true,
	});

	let $triggerEl = null;

	function closeItemSwitcher() {
		$(".switcher.expanded")
			.removeClass("expanded")
			.find(".toggle")
			.attr("aria-expanded", false);
		$(".switcher").find(".options").css("top", 0);
		if ($triggerEl) $triggerEl.focus();
	}

	$("body").on("keyup", function (e) {
		if (LS.isEscape(e)) {
			closeItemSwitcher();
		}
	});

	$(".switcher .toggle").on("click", function (e) {
		e.preventDefault();
		e.stopPropagation();
		$triggerEl = $(this);
		let $parent = $triggerEl.closest(".switcher");
		let $options = $parent.find(".options");
		let optionHeight = $options.find("li").first().outerHeight();
		let activeItemIndex = $options.find("li.active").index();
		$parent.toggleClass("expanded");
		if ($parent.hasClass("expanded")) {
			$(this).attr("aria-expanded", true);
			$options.css("top", optionHeight * activeItemIndex * -1);
		} else {
			closeItemSwitcher();
		}
		LS.trapFocus(`#${$(this).attr("aria-controls")}`);
	});

	$(".gallery-trigger").on("click", function (e) {
		e.preventDefault();
		let $this = $(this);
		$this
			.closest(".options")
			.find("li.active")
			.removeClass("active")
			.find("button")
			.removeAttr("tabindex");
		$this.attr("tabindex", -1).closest("li").addClass("active").blur();
		closeItemSwitcher();

		$this
			.closest(".item")
			.find(".gallery")
			.slick("slickUnfilter")
			.slick("slickFilter", `.product-${$this.data("value")}`);
	});

	$(".item .gallery").slick({
		prevArrow:
			'<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg width="13" height="23" viewBox="0 0 13 23" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11.6377 22.203L2 11.6015L11.6377 1.00009" stroke="#111111" stroke-width="1.5"/> </svg> </button>',
		nextArrow:
			'<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg width="12" height="23" viewBox="0 0 12 23" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.637701 22.2029L10.2754 11.6015L0.637701 1.00003" stroke="#111111" stroke-width="1.5"/> </svg> </button>',
	});

	$(".item .gallery").each(function () {
		$(this).slick(
			"slickFilter",
			`.product-${$(this).data("starting-product")}`
		);
	});
});
